/**
 * Shared id helper for the document library table.
 *
 * Bead: insurescope-zkolv.1.2.3.2 (Unit 2.IMPL.B).
 *
 * Both `useDocumentListTable` (IMPL.A) and `useLibrarySelection` (IMPL.B)
 * key on the same string id (`{prefix}-{numericId}`). Centralizing the
 * construction here keeps the two call sites in lockstep — if they diverge,
 * `rowSelection[id]` stops lining up with the internal `selectedItems` map
 * and cross-pagination selection silently breaks (Unit 2.RED #14).
 */
import type { ILibraryListItem } from "@/api";

export const ID_PREFIX: Record<ILibraryListItem["type"], string> = {
    folder: "folder",
    document: "doc",
    scope: "scope",
    comparison: "comp",
};

/**
 * Build the canonical row id from a backend item. The format
 * (`{prefix}-{numericId}`) matches what `itemToRow` already produces in
 * `DocumentList.tsx`; using this helper everywhere prevents drift.
 */
export function libraryItemRowId(item: ILibraryListItem): string {
    return `${ID_PREFIX[item.type]}-${item.id}`;
}
